<template>
  <v-container
    :class="'mt-0 pt-0 pb-0'"
    fluid
  >
    <v-card class="pa-0 ma-0 mt-5 mb-5" elevation="0">
      <v-row style="position: relative; align-items: center">
        <v-col class="my-0 py-0" cols="2">
          <SelectFilter
            class="mb-0 pb-0"
            :label="this.$t('cards.banks')"
            :get-request="this.$axios.banks"
            item-text="bankName"
            item-value="bankId"
            :selectAlone="false"
            :selectedItem="bankFilterArray"
            :disabled="2"
            :prepend-icon="'mdi-bank'"
            notMultiple
            v-on:changed="onChangeBankFilter"
            v-on:items="(items) => (banks = items)"
            style="z-index: 3"
          />
        </v-col>
        <v-col class="d-flex  my-0 py-0" cols="2">
          <SelectFilter
            :label="this.$t('cards.branches')"
            filtered
            :items-root="branchesOfBanks"
            notMultiple
            item-text="name"
            :disabled="this.$store.getters.CAN_SEE_BRANCHES ? 0 : 2"
            item-value="branchId"
            :selectedItem="branchFilterArray"
            :prepend-icon="'mdi-source-branch'"
            :no-data-text="branchesNoDataText"
            v-on:changed="onChangeBranchFilter"
            style="z-index: 200"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="2">
          <ComboboxFilterFunc
            :get-request="this.$axios.logs.types"
            :item-text="
              (value) => {
                return this.$t('Statuses.' + value.logTypeName);
              }
            "
            item-value="logTypeId"
            :selectedItems="logTypesFilterArray"
            :label="this.$t('Events.Type')"
            :prepend-icon="'mdi-alpha-t-circle-outline'"
            v-on:changed="
              (items) => {
                this.logTypesFilterArray = items;
              }
            "
            style="z-index: 3"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="3">
          <div>
            <DateFilter
              :label="this.$t('Date')"
              :dateBegin="dateBegin"
              :dateEnd="dateEnd"
              v-on:changed="
                (dateFrom, dateTo) => this.onDateChange(dateFrom, dateTo)
              "
            />
          </div>
        </v-col>
        <v-col class="py-0 my-0 " cols="2">
          <v-text-field
            small
            class="mb-0 pb-0"
            :label="this.$t('Events.Message')"
            :value="logMessageFilter"
            @change="(v) => (logMessageFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (logMessageFilter = '')"
            :prepend-icon="'mdi-text-box-outline'"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="0">
          <v-row>
            <v-spacer />
            <SearchButtons
              v-on:clear="clearFilters"
              v-on:get="onSearch"
              v-on:showHide="onShowHideFilters"
              :isShow="showAdditionalFilters"
              style="z-index: 3"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0" cols="2">
          <ComboboxFilter
            :label="this.$t('cards.devices')"
            filtered
            :selectedItems="deviceFilterArray"
            :items-root="devicesOfBanks"
            item-text="deviceName"
            item-value="deviceId"
            :prepend-icon="'mdi-cash-register'"
            :noDataText="devicesNoDataText"
            v-on:changed="
              (items) => {
                this.deviceFilterArray = items;
              }
            "
          />
        </v-col>
        <v-col class="py-0" cols="2">
          <ComboboxFilter
            :label="this.$t('cards.products')"
            filtered
            :selectedItems="productFilterArray"
            :items-root="productsOfBanks"
            :prepend-icon="'mdi-alpha-p-circle-outline'"
            item-text="productName"
            item-value="productId"
            :noDataText="productsNoDataText"
            v-on:changed="
              (items) => {
                this.productFilterArray = items;
              }
            "
          />
        </v-col>
        <v-col class="py-0" cols="2">
          <v-text-field
            class="mb-0 pb-0"
            :label="this.$t('cards.JobName')"
            :value="jobNameFilter"
            @change="(v) => (jobNameFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (jobNameFilter = '')"
            :prepend-icon="'mdi-file-document-outline'"
          />
        </v-col>
        <v-col class="py-0">
          <v-text-field
            class="mb-0 pb-0"
            :label="this.$t('Events.UserSubject')"
            :value="logUserNameFilter"
            @change="(v) => (logUserNameFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (logUserNameFilter = '')"
            :prepend-icon="'mdi-badge-account-outline'"
          />
        </v-col>
        <v-col class="py-0">
          <v-text-field
            class="mb-0 pb-0"
            :label="this.$t('Events.Performer')"
            :value="userNameFilter"
            @change="(v) => (userNameFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (userNameFilter = '')"
            :prepend-icon="'mdi-account-tie'"
          />
        </v-col>
      </v-row>
    </v-card>
    <v-card class="mt-2">
      <v-card-title class="my-0 pb-1 pt-2">
        <div>
          {{ $t("EventLog") }}
        </div>
        <v-divider class="mx-4 " inset vertical> </v-divider>
        <v-spacer />
        <v-col cols="2" class="py-0">
          <v-select
            v-on:change="getData"
            v-model="limit"
            :items="limitValues"
            :label="this.$t('cards.rowsPerPage')"
            item-text="value"
            item-value="value"
          />
        </v-col>
      </v-card-title>
      <v-data-table
        fixed-header
        :headers="headers"
        :items="logs"
        item-key="logRecordId"
        :disable-pagination="true"
        :no-data-text="noDataText"
        must-sort
        :sort-by.sync="currentSort"
        :sort-desc.sync="currentSortDesc"
        :custom-sort="customSort"
        hide-default-footer
        :loading="loading"
        :loading-text="$t('LoadingText')"
        @click:row="onClickRow"
        :height="tableHeight"
      >
        <template v-slot:[`item.logDateTime`]="{ item }">
          {{ item.logDateTime | formatDate }}
        </template>
        <template v-slot:item.logTypeName="{ item }">
          {{ $t("Statuses." + item.logTypeName) }}
        </template>
        <template v-slot:item.additionalInformation="{ item }">
          <v-tooltip
            v-if="
              item.objects !== undefined &&
                item.objects !== null &&
                item.objects.length !== 0
            "
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-icon class="ml-1" color="black" dark v-on="on">mdi-eye</v-icon>
            </template>
            <span
              v-for="information in getAdditionalInformation(
                item.logTypeId,
                item.objects
              )"
              :key="information.value"
            >
              {{
                additionalNames[information.name] !== undefined &&
                additionalNames[information.name] !== null
                  ? additionalNames[information.name]
                  : information.name
              }}:
              {{ information.value }}
              <br />
            </span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-dialog v-model="showForm" @close="this.$emit('rerender')">
        <v-card v-if="selectedItem !== null">
          <v-card-title>
            <span>{{ $t("Statuses." + selectedItem.logTypeName) }}</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              class="data-table-multiline"
              fixed-header
              :headers="formHeaders"
              :items="fullInformation"
              item-key="logRecordId"
              :disable-pagination="true"
              :no-data-text="noDataText"
              hide-default-footer
              :height="fullInfoHeight"
            >
              <template v-slot:item="{ item }">
                <td style="vertical-align: top; padding-top: 5px">
                  {{ item.logDateTime | formatDate }}
                </td>
                <td
                  v-if="item.bankName !== undefined"
                  style="vertical-align: top; padding-top: 5px"
                >
                  {{ item.bankName }}
                </td>
                <td
                  v-if="item.branchName !== undefined"
                  style="vertical-align: top; padding-top: 5px"
                >
                  {{ item.branchName }}
                </td>
                <td style="vertical-align: top; padding-top: 5px">
                  {{ item.logMessage }}
                </td>
                <td
                  v-if="item.jobName !== undefined"
                  style="vertical-align: top; padding-top: 5px"
                >
                  {{ item.jobName }}
                </td>
                <td
                  v-if="item.productName !== undefined"
                  style="vertical-align: top; padding-top: 5px"
                >
                  {{ item.productName }}
                </td>
                <td
                  v-if="item.deviceName !== undefined"
                  style="vertical-align: top; padding-top: 5px"
                >
                  {{ item.deviceName }}
                </td>
                <td
                  v-if="item.pan !== undefined"
                  style="vertical-align: top; padding-top: 5px"
                >
                  {{ item.pan }}
                </td>
                <td
                  v-if="item.name !== undefined"
                  style="vertical-align: top; padding-top: 5px"
                >
                  {{ item.name }}
                </td>
              </template>
            </v-data-table>
            <v-row>
              <v-spacer />
              <v-btn
                class="mt-2"
                v-on:click="() => (this.showForm = false)"
                dark
                color="primary"
              >
                {{ $t("Close") }}
              </v-btn>
              <v-spacer />
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
    <v-row align="start" class="mt-3">
      <v-col class="d-flex">
        <v-row  style="display: flex; justify-content: center">
          <v-pagination
            v-on:input="getData"
            v-model="page"
            :length="paginationLength"
            :total-visible="totalVisible"
          />
        </v-row>
      </v-col>
      <p class="d-flex v-card__title">
        {{ $t("cards.records") }} {{ $t("from") }} {{ limit * (page - 1) + 1 }}
        {{ $t("to") }} {{ limit * page }}
      </p>
      <p align="right" class="d-flex v-card__title">
        {{ $t("cards.total") }}: {{ totalCount }}
      </p>
    </v-row>
  </v-container>
</template>

<script>
import SearchButtons from '@/components/FiltersComponent/SearchButtons';
import Vue from 'vue';
import { notifyError, notifySuccess } from '@/services/notifications';
import SelectFilter from '../components/FiltersComponent/SelectFilter';
import ComboboxFilter from '../components/FiltersComponent/ComboboxFilter';
import ComboboxFilterFunc from '../components/FiltersComponent/ComboboxFilterWhithFunction';
import DateFilter from '../components/FiltersComponent/DateFilter';
import { NamesDB } from '@/constants/DBNames.js';
import tableHeightMixin from './mixins/tableHeightMixin';

export default {
  name: 'Banks',
  mixins: [tableHeightMixin],
  components: {
    SearchButtons,
    SelectFilter,
    ComboboxFilter,
    ComboboxFilterFunc,
    DateFilter,
  },
  data() {
    return {
      //Table
      currentSortDesc: [],
      currentSort: [],
      logs: [],
      additionalInformation: [],

      // Для расчёта высоты таблицы
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,
      headerH: 48,
      filterH: 124,
      tHeaderH: 68,
      tFooterH: 68,
      infelicity: 8,

      noData: false,
      loading: false,

      tempBanks: [],
      sortBy: [],
      sortDesc: [],

      limit: 10,
      page: 1,
      totalCount: '0',
      limitValues: [{ value: 10 }, { value: 25 }, { value: 50 }],
      paginationLength: 1,
      totalVisible: 10,

      apiUri: 'http://192.168.1.231/api',

      //Filters
      showAdditionalFilters: false,

      bankFilterArray: [],
      branchFilterArray: [],
      logTypesFilterArray: [],
      deviceFilterArray: [],
      productFilterArray: [],
      dateBegin: '',
      dateEnd: '',
      jobNameFilter: '',
      userNameFilter: '',
      logUserNameFilter: '',
      logMessageFilter: '',

      banks: [],
      branches: [],
      productsByBanks: [],
      devicesByBanksOrBranches: [],

      products: [],
      selectedProducts: [],
      productsSingleSelect: false,

      deviceFilter: '',

      // Form
      fullInformation: [],
      fullInfoHeight: '300px',
      selectedItem: null,
      showForm: false,
      additionalProp: {
        '1': ['jobName', 'productName', 'deviceName'],
        '3': ['pan', 'deviceName'],
        '4': ['pan'],
        '200': ['pan', 'deviceName', 'productName'],
        '201': ['pan', 'deviceName', 'productName'],
        '202': ['pan', 'deviceName', 'productName'],
        '203': ['pan', 'deviceName', 'productName'],
        '204': ['pan', 'deviceName', 'productName'],
        '205': ['pan', 'deviceName', 'productName'],
        '206': ['pan', 'deviceName', 'productName'],
        '207': ['pan', 'deviceName', 'productName'],
        '208': ['pan', 'deviceName', 'productName'],
        '209': ['pan', 'deviceName', 'productName'],
        '210': ['pan', 'deviceName', 'productName'],
        '211': ['pan', 'deviceName', 'productName'],
        '212': ['pan', 'deviceName', 'productName'],
        '213': ['pan', 'deviceName', 'productName'],
        '214': ['pan', 'deviceName', 'productName'],
        '215': ['pan', 'deviceName', 'productName'],
        '216': ['pan', 'deviceName', 'productName'],
        '217': ['pan', 'deviceName', 'productName'],
        '218': ['pan', 'deviceName', 'productName'],
        '501': ['deviceName'],
        '502': ['deviceName'],
        '503': ['deviceName'],
        '504': ['deviceName'],
        '505': ['deviceName'],
        all: ['bankName', 'branchName'],
      },
      detailsProp: {
        '1': ['pan'],
        '3': [],
        '4': [],
        '200': [],
        '201': [],
        '202': [],
        '203': [],
        '204': [],
        '205': [],
        '206': [],
        '207': [],
        '208': [],
        '209': [],
        '210': [],
        '211': [],
        '212': [],
        '213': [],
        '214': [],
        '215': [],
        '216': [],
        '217': [],
        '218': [],
        '501': ['productName'],
        '502': ['productName'],
        '503': ['productName'],
        '504': ['productName'],
        '505': ['productName'],
      },
    };
  },
  watch: {
    filterJson() {
      this.getData();
    },
    async currentSortDesc() {
      this.getData();
    },
    async currentSort(val) {
      if (val.length != 0) this.getData();
    },
    logs() {
      if (
        this.logs !== undefined &&
        this.logs !== null &&
        this.logs.length != 0
      )
        this.setAdditionalInformation();
    },
  },
  computed: {
    additionalFiltersVisibility() {
      if (this.showAdditionalFilters) return 'z-index: 3; visibility: visible';

      return 'z-index: 0;  visibility: hidden';
    },
    //Table
    formHeaders() {
      if (this.fullInformation[0] === undefined) return {};

      const needsort = false;

      const res = [
        {
          text: this.$t('Date'),
          value: 'logDateTime',
          sortable: needsort,
          width: '165px',
        },
      ];

      if (this.fullInformation[0].bankName !== undefined)
        res.push({
          text: this.$t('referenceBooks.banks.Name'),
          value: 'bankName',
          sortable: needsort,
          width: '165px',
        });

      if (this.fullInformation[0].branchName !== undefined)
        res.push({
          text: this.$t('referenceBooks.branches.Name'),
          value: 'branchName',
          sortable: needsort,
          width: '165px',
        });

      res.push({
        text: this.$t('Events.Message'),
        value: 'logMessage',
        sortable: needsort,
        width: '200px',
      });

      if (this.fullInformation[0].jobName !== undefined)
        res.push({
          text: this.$t('cards.JobName'),
          value: 'jobName',
          sortable: needsort,
          width: '165px',
        });

      if (this.fullInformation[0].productName !== undefined)
        res.push({
          text: this.$t('referenceBooks.products.Name'),
          value: 'productName',
          sortable: needsort,
          width: '165px',
        });

      if (this.fullInformation[0].deviceName !== undefined)
        res.push({
          text: this.$t('referenceBooks.devices.Name'),
          value: 'deviceName',
          sortable: needsort,
          width: '165px',
        });

      if (this.fullInformation[0].pan !== undefined)
        res.push({
          text: this.$t('cards.pan'),
          value: 'pan',
          sortable: needsort,
          width: '165px',
        });

      if (
        this.fullInformation[0].name !== null &&
        this.fullInformation[0].name !== undefined
      )
        res.push({
          text: this.$t('referenceBooks.users.UserName'),
          value: 'name',
          sortable: needsort,
          width: '165px',
        });

      return res;
    },
    headers() {
      const needsort = false;

      return [
        { text: '', value: '0', sortable: false, width: '1px' },
        {
          text: this.$t('Date'),
          value: 'logDateTime',
          sortable: needsort,
          width: '165px',
        },
        {
          text: '',
          value: 'additionalInformation',
          sortable: needsort,
          width: '40px',
        },
        {
          text: this.$t('Events.Message'),
          value: 'logMessage',
          sortable: needsort,
        },
        {
          text: this.$t('Type'),
          value: 'logTypeName',
          sortable: needsort,
          width: '200px',
        },
        {
          text: this.$t('referenceBooks.users.UserName'),
          value: 'name',
          sortable: needsort,
          width: '300px',
        },
      ];
    },
    noDataText() {
      return this.$t('cards.noData');
    },
    additionalNames() {
      return {
        bankName: this.$t('referenceBooks.banks.Name'),
        branchName: this.$t('referenceBooks.branches.Name'),
        deviceName: this.$t('referenceBooks.devices.Name'),
        productName: this.$t('referenceBooks.products.Name'),
        username: this.$t('referenceBooks.users.UserName'),
        jobName: this.$t('cards.JobName'),
        pan: this.$t('cards.pan'),
      };
    },
    branchesNoDataText() {
      if (
        this.bankFilterArray === null ||
        this.bankFilterArray === undefined ||
        this.bankFilterArray.length === 0
      )
        return this.$t('Events.NoDataText.ChooseBank');

      return this.$t('Events.NoDataText.NoBranches');
    },
    devicesNoDataText() {
      if (
        this.bankFilterArray === null ||
        this.bankFilterArray === undefined ||
        this.bankFilterArray.length === 0
      )
        return this.$t('Events.NoDataText.ChooseBank');

      return this.$t('Events.NoDataText.NoDevices');
    },
    productsNoDataText() {
      if (
        this.bankFilterArray === null ||
        this.bankFilterArray === undefined ||
        this.bankFilterArray.length === 0
      )
        return this.$t('Events.NoDataText.ChooseBank');

      return this.$t('Events.NoDataText.NoProducts');
    },

    //Filters
    branchesOfBanks() {
      if (this.bankFilterIsEmpty()) return [];

      return this.branches;
    },
    productsOfBanks() {
      if (this.bankFilterIsEmpty()) return [];

      return this.productsByBanks;
    },
    devicesOfBanks() {
      if (this.bankFilterIsEmpty()) return [];

      return this.devicesByBanksOrBranches;
    },

    //JSON
    filterJson() {
      const result = {};

      result.BranchesId =
        this.branchFilterArray == null || this.branchFilterArray.length == 0
          ? []
          : [this.branchFilterArray.branchId];
      result.BanksId =
        this.bankFilterArray == null || this.bankFilterArray.length == 0
          ? []
          : [this.bankFilterArray.bankId];

      result.DevicesId = this.deviceFilterArray.map(
        (device) => device.deviceId
      );
      result.ProductsId = this.productFilterArray.map(
        (product) => product.productId
      );

      result.LogTypesId = this.logTypesFilterArray.map(
        (type) => type.logTypeId
      );
      result.JobName = !this.jobNameFilter ? '' : this.jobNameFilter;
      result.UserName = !this.userNameFilter ? '' : this.userNameFilter;
      result.LogUserName = !this.logUserNameFilter
        ? ''
        : this.logUserNameFilter;
      result.LogMessage = !this.logMessageFilter ? '' : this.logMessageFilter;

      if (
        this.dateBegin != undefined &&
        this.dateBegin != null &&
        this.dateBegin != ''
      )
        result.LogDateFrom = this.dateBegin;
      if (
        this.dateEnd != undefined &&
        this.dateEnd != null &&
        this.dateEnd != ''
      )
        result.LogDateTo = this.dateEnd;

      return result;
    },
    bankIdJson() {
      let result = {};
      result = this.bankFilterIsEmpty() ? [] : [this.bankFilterArray.bankId];

      return result;
    },
    branchIdJson() {
      let result = {};
      result = this.branchFilterIsEmpty()
        ? []
        : [this.branchFilterArray.branchId];

      return result;
    },
    OrderBy() {
      const Sort = [];

      for (let i = 0; i < this.currentSort.length; i++) {
        Sort.splice(0, 0, {
          Name: NamesDB[this.currentSort[i]],
          SortUp: !this.currentSortDesc[i],
        });
      }

      return { Sort };
    },
  },
  async mounted() {
    this.setDefaultSort();
    this.getData();
  },
  filters: {
    formatDate(dateString) {
      const date = new Date(dateString);
      if (date === undefined) return dateString;
      else {
        return date.toLocaleString();
      }
    },
  },
  methods: {
    customSort: function(items) {
      return items;
    },
    // Events handlers
    onChangeBankFilter(items) {
      this.bankFilterArray = items;
      this.getBranches();
      this.getProducts();
      this.getDevices();
    },
    onChangeBranchFilter(items) {
      this.branchFilterArray = items;
      this.getDevices();
    },
    onDateChange(dateFrom, dateTo) {
      this.dateBegin = dateFrom;
      this.dateEnd = dateTo;
    },
    onError(error, errorHeader = '') {
      this.catchError(error, null, errorHeader);
    },
    onShowHideFilters(value) {
      this.showAdditionalFilters = value;
    },
    async onClickRow(value) {
      this.selectedItem = await this.getLogInfo(value.logRecordId);
      this.fullInformation = await this.getFullInfo();
      this.showForm = true;
    },
    onSearch() {
      this.page = 1;
      this.getData();
      this.showAdditionalFilters = false;
    },
    onCloseFormClick() {
      this.showAdditionalFilters = false;
    },
    //Gets
    async getBranches() {
      if (this.bankFilterIsEmpty()) {
        this.clearBranches();

        return;
      }

      await this.getBranchesByBankId();
    },

    getBranchesByBankId() {
      this.$axios.branches
        .getByBanksArrayForLogs(this.bankIdJson)
        .then((response) => response.data)
        .then((json) => {
          this.branches =Array.isArray(json) ? json : [];
        })
        .catch((error) => {
          this.onError(error, this.$t('Events.GetBranchesFailed'));
        });
    },
    async getProducts() {
      this.productFilterArray = [];
      if (this.bankFilterIsEmpty()) {
        this.clearProducts();

        return;
      }

      await this.getProductsByBankId();
    },
    getProductsByBankId() {
      this.$axios.products
        .getByBanksArrayForLogs(this.bankIdJson)
        .then((response) => response.data)
        .then((json) => {
          this.productsByBanks = Array.isArray(json) ? json : [];
        })
        .catch((error) => {
          this.onError(error, this.$t('Events.GetProductsFailed'));
        });
    },
    getDevices() {
      this.deviceFilterArray = [];
      if (this.bankFilterIsEmpty()) {
        this.clearDevices();

        return;
      }

      if (this.branchFilterIsEmpty()) this.getDevicesByBankId();
      else this.getDevicesByBranchId();
    },
    getDevicesByBankId() {
      this.$axios.devices
        .getByBanksArrayForLogs(this.bankIdJson)
        .then((response) => response.data)
        .then((json) => {
          this.devicesByBanksOrBranches = Array.isArray(json) ? json : [];
        })
        .catch((error) => {
          this.onError(error, this.$t('Events.GetDevicesFailed'));
        });
    },
    getDevicesByBranchId() {
      this.$axios.devices
        .getByBranchesArrayForLogs(this.branchIdJson)
        .then((response) => response.data)
        .then((json) => {
          this.devicesByBanksOrBranches = Array.isArray(json) ? json : [];
        })
        .catch((error) => {
          this.onError(error, this.$t('Events.GetDevicesFailed'));
        });
    },
    async getData() {
      this.selectedLog = [];

      if (this.loading) return;

      const orderBy = this.OrderBy;

      this.loading = true;
      const params = {
        query: JSON.stringify(this.filterJson),
      };
      this.getCount(params);
      params.limit = this.limit;
      params.offset = this.limit * (this.page - 1);
      if (orderBy.Sort != undefined && orderBy.Sort != null)
        params.orderby = JSON.stringify(orderBy);
      this.executeRequest(params);
    },
    async getCount(params) {
      this.$axios.logs
        .getCount(params)
        .then((response) => response.data)
        .then((json) => {
          this.paginationLength = Math.ceil(json.totalCount / this.limit);
          this.totalCount = json.totalCount;
        })
        .catch((error) => {
          this.onError(error, this.$t('Events.GetCountFailed'));
        });
    },
    async executeRequest(params) {
      await this.$axios.logs
        .get(params)
        .then((response) => response.data)
        .then((json) => {
          if(!Array.isArray(json)) json = [];
          this.logs = this.sortData(json, this.sortBy, this.sortDesc);
          this.loading = false;
          this.noData = this.logs == null || this.logs.length == 0;
        })
        .catch((error) => {
          this.onError(error, this.$t('Events.GetFailed'));
          this.loading = false;
        });
    },
    getAdditionalInformation(id, elements) {
      if (elements === undefined || elements === null || elements.length === 0)
        return [];

      const res = [];
      const ind = id.toString();

      elements.forEach((element) => {
        for (const [key, value] of Object.entries(element)) {
          if (
            (this.additionalProp[ind] !== undefined &&
              this.additionalProp[ind] !== null &&
              this.additionalProp[ind].find((value) => value === key) !==
                undefined) ||
            this.additionalProp.all.find((value) => value === key) !== undefined
          ) {
            if (res.find((pair) => pair.name === key) === undefined)
              res.push({ name: key, value: [] });

            const i = res.findIndex((pair) => pair.name === key);

            res[i].value.push(value);
          }
        }
      });

      return res;
    },
    getDetails(id, elements) {
      if (elements === undefined || elements === null || elements.length === 0)
        return [];

      const res = [];
      const ind = id.toString();

      elements.forEach((element) => {
        for (const [key, value] of Object.entries(element)) {
          if (
            this.detailsProp[ind] !== undefined &&
            this.detailsProp[ind] !== null &&
            this.detailsProp[ind].find((value) => value === key) !== undefined
          ) {
            if (res.find((pair) => pair.name === key) === undefined)
              res.push({ name: key, value: [] });

            const i = res.findIndex((pair) => pair.name === key);

            res[i].value.push(value);
          }
        }
      });

      return res;
    },
    getFullInfo() {
      const res = {};

      res.logDateTime = this.selectedItem.logDateTime;

      res.name = this.selectedItem.name;

      res.logMessage = this.selectedItem.logMessage;

      const addInf = this.getAdditionalInformation(
        this.selectedItem.logTypeId,
        this.selectedItem.objects
      );

      addInf.forEach((element) => {
        let str = '';

        element.value.forEach((val) => {
          str += val + '\n';
        });

        res[element.name] = str;
      });

      const details = this.getDetails(
        this.selectedItem.logTypeId,
        this.selectedItem.objects
      );

      details.forEach((element) => {
        let str = '';

        element.value.forEach((val) => {
          str += val + '\n';
        });

        res[element.name] = str;
      });

      return [res];
    },
    async getLogInfo(id) {
      let res;

      await this.$axios.logs
        .getById(id)
        .then((response) => response.data)
        .then((json) => {
          res = json;
        })
        .catch((error) => {
          this.onError(error, this.$t('referenceBooks.banks.GetFailed'));
        });

      return res;
    },

    //Sets
    setAdditionalInformation() {
      this.additionalInformation = [];

      this.logs.forEach((element) => {
        this.additionalInformation.push(
          this.getAdditionalInformation(element.objects)
        );
      });
    },

    //Checks
    bankFilterIsEmpty() {
      return this.bankFilterArray == null || this.bankFilterArray.length === 0;
    },
    branchFilterIsEmpty() {
      return (
        this.branchFilterArray == null || this.branchFilterArray.length === 0
      );
    },

    //Clean
    clearBranches() {
      this.branches = null;
      this.branchesFlag = null;
    },
    clearProducts() {
      this.productsByBanks = null;
      this.productFilterArray = [];
    },
    clearDevices() {
      this.devicesByBanksOrBranches = null;
      this.deviceFilterArray = [];
    },
    clearDate() {
      this.dateBegin = '';
      this.dateEnd = '';
    },
    clearTypes() {
      this.logTypesFilterArray = [];
    },

    checkFilters() {
      return false; //(this.bankFilter == null || this.bankFilter.length == 0);
    },
    clearFilters() {
      if (this.banks.length > 1) {
        this.bankFilterArray = [];
        this.branchFilterArray = [];
      } else if (this.banks.length === 1 && this.branches.length > 1) {
        this.branchFilterArray = [];
      }

      this.logMessageFilter = '';
      this.userNameFilter = '';
      this.logUserNameFilter = '';
      this.jobNameFilter = '';

      this.clearProducts();
      this.clearDevices();
      this.clearDate();
      this.clearTypes();

      this.page = 1;

      this.showAdditionalFilters = false;

      this.getData();
    },
    onChangeSort(sort) {
      this.sortBy = sort;

      if (this.sortDesc.length === this.sortBy.length)
        this.banks = this.sortData(
          this.tempBanks,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    onChangeSortDesc(sortDesc) {
      this.sortDesc = sortDesc;

      if (this.sortDesc.length === this.sortBy.length)
        this.banks = this.sortData(
          this.tempBanks,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    sortData(items, sortBy, desc) {
      items.sort(function(a, b) {
        let index = 0;

        while (index < sortBy.length) {
          const isDesc =
            desc !== null && desc[index] !== null && desc[index] === true
              ? true
              : false;

          if (a[sortBy[index]] > b[sortBy[index]]) return isDesc ? -1 : 1;
          if (a[sortBy[index]] < b[sortBy[index]]) return isDesc ? 1 : -1;
          index++;
        }

        return 0;
      });

      return items;
    },
    setDefaultSort() {
      this.currentSort.splice(0, 0, 'logDateTime');
      this.currentSortDesc.splice(0, 0, true);
    },
    async onDelete(bank) {
      await this.$axios.banks
        .delete(bank.bankId)
        .then(() => {
          notifySuccess(
            '',
            this.$t('Messages.BankWasDeleted', [bank.bankName])
          );
          this.getData();
        })
        .catch((error) => {
          console.error(error);

          notifyError('', this.$t('Error'));
          this.catchError(
            error,
            bank.bankName,
            this.$t('errorsMessages.Delete')
          );
        });
    },
    catchError(error, name, errorHeader = '') {
      console.error(error);
      const status = error.response.status;
      const data = [error.response.data];

      const errorHeaderActual =
        errorHeader === '' ? this.$t('Error') : errorHeader;

      if (status === 400 || status === 401) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].errorType === 'HAS_RELATIONS') {
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.propertiesResponse[data[i].property]}<br>${this.$t(
                'referenceBooks.banks.Name'
              )}: ${name}`,
              'error'
            );
          } else if (data[i].errorType === 'NO_RIGHTS') {
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.$t('errorsMessages.NoRights')}`,
              'error'
            );
          } else this.showMessage(errorHeaderActual, error, 'error');
        }
      } else {
        this.showMessage(errorHeaderActual, error, 'error');
      }
    },
    markRow(id) {
      this.changedBanksId = [];
      this.changedBanksId.push(id);
    },
    showMessage(title, text, type = '') {
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
  },
};
</script>